export const DynamicIsland = () => (
	<div className="absolute left-1/2 top-[6px] z-[1] h-[20px] w-[71px] -translate-x-1/2 rounded-full bg-black">
		<div className="absolute right-[6px] top-1/2 size-[10px] -translate-y-1/2 rounded-full bg-white/10" />
	</div>
)
